module.exports = __webpack_public_path__ + "img/stock7.ff6caea9.png";